export const SUBSCRIPTION_CACHE_NAME = {
  DIGITAL_VOUCHER_SERVICE_FEE: 'digital_voucher_service_fee__expired_at',
  JAGOAN_VIRTUAL: 'jagoan_virtual_expired_at',
  REFUND_STANDALONE: 'refund_standalone_expired_at',
};

export const ALLOWLIST_FEATURE = {
  REFUND_STANDALONE: 'refund_standalone',
  JAGOAN_VIRTUAL: 'jagoan_virtual',
  MITRA_BRANCH: 'mitra_branch',
  DIGITAL_VOUCHER_SERVICE_FEE: 'digital_voucher_service_fee',
};
